


















































import { computed, defineComponent, watch } from '@vue/composition-api';
import LoaderState from '@front-app/components/LoaderState.vue';
import { ButtonNavButton } from '@front-app/components/buttons/buttonNav';
import ErrorCard from '@front-app/components/cards/state/ErrorCard.vue';
import ColumnHeader from '@front-app/components/layouts/columns/ColumnHeader.vue';
import PaddedContent from '@front-app/components/layouts/columns/PaddedContent.vue';
import ScrollingColumn from '@front-app/components/layouts/columns/ScrollingColumn.vue';
import TabbedNav from '@front-app/components/tabs/TabbedNav.vue';
import { GroupsStore } from '@front-app/store/singletons/Groups';
import { useTabbedNav } from '@front-app/components/tabs/useTabbedNav';
import { Routes } from '@front-app/constants/routes';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import { useTranslate } from '@front-app/hooks/useTranslate';
import { useEventAdminStore } from '@front-app/modules/event/store/EventAdmin';
import { useEventStore } from '@front-app/modules/event/store/Event';
import ColumnContainer from '@front-app/components/layouts/columns/ColumnContainer.vue';

enum EventAdminTabs {
	EVENT_DETAILS = 'event_details',
	MANAGE_EVENT = 'manage_event',
}

const ROUTE_TO_TAB: {[key: string]: string} = {
	[Routes.EVENT_ADMIN_DETAILS]: EventAdminTabs.EVENT_DETAILS,
	[Routes.EVENT_ADMIN_MANAGEMENT]: EventAdminTabs.MANAGE_EVENT,
};

const TAB_BUTTONS: ButtonNavButton[] = [
	{
		key: EventAdminTabs.EVENT_DETAILS,
		id: EventAdminTabs.EVENT_DETAILS,
		label: 'event-admin.event-details',
		to: { name: Routes.EVENT_ADMIN_DETAILS },
	},
	{
		key: EventAdminTabs.MANAGE_EVENT,
		id: EventAdminTabs.MANAGE_EVENT,
		label: 'event-page.manage-event',
		to: { name: Routes.EVENT_ADMIN_MANAGEMENT },
	},
];

export default defineComponent({
	components: {
		ColumnHeader,
		ErrorCard,
		LoaderState,
		PaddedContent,
		ScrollingColumn,
		TabbedNav,
		ColumnContainer,
	},
	props: {
		eventId: {
			type: String,
			required: true,
		},
	},
	setup(props, ctx) {
		const {
			track,
			isError: isErrorFetchingEvent,
			isLoading: isFetchingEvent,
			isSuccess: isFetchingEventSuccess,
		} = useAsyncStatus();
		watch(() => props.eventId, () => {
			track(Promise.all([
				// Fetch groups to be available in the store for use in Manage Event tab
				GroupsStore.getInstance().fetchGroupsOnce(),
				useEventAdminStore().fetch(props.eventId),
				useEventStore().fetch(props.eventId),
			]));
		}, { immediate: true });

		// Back button
		const backButtonRoute = computed(() => {
			if (ctx.root.$route.params.groupId) {
				return { name: Routes.GROUP_EVENTS };
			}
			return { name: Routes.EVENTS };
		});
		const $t = useTranslate(ctx);
		const backButtonLabel = computed(() => {
			if (ctx.root.$route.params.groupId) {
				return $t('group.event.back-to-events');
			}
			return $t('event-admin.back-to-events');
		});
		// END Back button

		// Tabs
		const {
			tabButtons,
			currentTabKey,
		} = useTabbedNav(ctx, TAB_BUTTONS, ROUTE_TO_TAB);
		// END Tabs

		return {
			isErrorFetchingEvent,
			isFetchingEvent,
			isFetchingEventSuccess,
			// Back button
			backButtonRoute,
			backButtonLabel,
			// Tabs
			tabButtons,
			currentTabKey,
		};
	},
});
